import { usePostApiV1ExamQuestionLibraryAiCorrection } from '@/shared/api/generated';

/**
 * Hook para solicitar a revisão de uma questão em edição por IA.
 *
 * Envolve o hook gerado pelo Kubb para
 * `POST /api/v1/exam/question-library/ai-correction`. Recebe a questão atual
 * (enunciado, informação, alternativas, etc.) e retorna um
 * `ExamItemRevisionResultViewModel` com a versão revisada em `item` e um resumo
 * opcional da IA em `summary`, sem persistir nada no servidor — por isso não há
 * invalidação de cache.
 *
 * @returns Mutation do TanStack Query para o endpoint de revisão com IA
 *
 * @example
 * ```tsx
 * const { mutate: reviewQuestion, isPending } = useQuestionAiReview();
 * reviewQuestion(
 *   { data: request },
 *   { onSuccess: result => console.log(result.item?.label, result.summary) },
 * );
 * ```
 */
export function useQuestionAiReview() {
  return usePostApiV1ExamQuestionLibraryAiCorrection();
}
